// TourGuide gate — a tour is eligible exactly when the server-side
// flag is explicitly false (missing → UserOut default false via /me).
import { useCallback, useRef, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { patchTours } from "../api/tourApi";

export function useTour(flagKey) {
  const { user, refreshUser } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const finishingRef = useRef(false);

  const eligible = !!user && user[flagKey] === false && !dismissed;

  const finish = useCallback(async () => {
    if (finishingRef.current) return;
    finishingRef.current = true;
    setDismissed(true);
    try {
      await patchTours({ [flagKey]: true });
      await refreshUser();
    } catch {
      /* non-fatal — tour re-arms on next visit if persist failed */
    }
  }, [flagKey, refreshUser]);

  return { eligible, finish };
}
